export default function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="border-b border-[#E5E7EB] bg-white px-10 py-8 flex items-end justify-between gap-6">
      <div>
        {eyebrow && (
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#2563EB] font-semibold mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-extrabold text-4xl tracking-tight text-[#09090B]">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#52525B] mt-2 max-w-2xl text-sm leading-relaxed">{subtitle}</p>
        )}
      </div>
      {action}
    </div>
  );
}
